<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-if="$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-spacer />
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="white" icon v-bind="attrs" v-on="on">
							<v-icon>mdi-menu</v-icon>
						</v-btn>
					</template>
					<v-list dense>
						<v-list-item
							@click="$router.push({ name: 'constructions_information_print', params: { id } })"
						>
							<v-icon class="mr-1">mdi-printer-outline</v-icon>
							印刷
						</v-list-item>
						<v-list-item
							@click="$router.push({ name: 'constructions_preparation_edit', params: { id } })"
						>
							<v-icon class="mr-1">mdi-pencil</v-icon>
							準備入力
						</v-list-item>
						<v-list-item
							@click="$router.push({ name: 'constructions_report_edit', params: { id } })"
						>
							<v-icon class="mr-1">mdi-pencil</v-icon>
							報告書入力
						</v-list-item>
					</v-list>
				</v-menu>
			</template>
			<v-row no-gutters justify="end">
				<ConfirmationDialog
					v-if="showRequirementBtn"
					@accept="sendRequirement"
					:confirm_options="requirementOptions"
					requireBtn
				>
					<template v-slot:open-btn-content>
						<v-icon class="mr-1">mdi-send</v-icon>
						{{ requirementOptions.accept_text }}
					</template>
					<template v-slot:text>
						<table width="100%" class="mt-2 show-dialog-table show-dialog-table--form">
							<tbody>
								<ShowDetailRecord :columnName="'依頼内容'">
									<template v-slot:value>
										<v-select
											v-model="selectedRequirement"
											:items="requirement_types"
											item-value="id"
											item-text="name"
											dense
											outlined
											hide-details
											background-color="white"
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'対象者'">
									<template v-slot:value>
										<v-select
											v-model="selectedUser"
											:items="users"
											item-value="id"
											item-text="full_name"
											dense
											outlined
											hide-details
											background-color="white"
										/>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
					</template>
				</ConfirmationDialog>
				<ConfirmationDialog
					v-if="showConfirmationBtn"
					@accept="confirmRequirement"
					:confirm_options="confirmOptions"
					requireBtn
				>
					<template v-slot:open-btn-content>
						<template v-if="currentStatus == 'TODO'">
							<v-icon class="mr-1">mdi-check</v-icon>
							{{ confirmOptions.accept_text }}
						</template>
					</template>
					<template v-slot:text>
						<table width="100%" class="mt-2 show-dialog-table">
							<tbody>
								<ShowDetailRecord :columnName="'項目名'" :value="pendingItemName" />
								<ShowDetailRecord
									:columnName="'確認者'"
									:value="$store.getters['auth/authData'].full_name"
								/>
							</tbody>
						</table>
					</template>
				</ConfirmationDialog>
				<template v-if="!$vuetify.breakpoint.xs">
					<v-btn
						class="ml-2"
						color="secondary"
						@click="$router.push({ name: 'constructions_information_print', params: { id } })"
					>
						<v-icon class="mr-1">mdi-printer-outline</v-icon>
						印刷
					</v-btn>
					<v-btn
						class="ml-2"
						color="secondary"
						@click="$router.push({ name: 'constructions_preparation_edit', params: { id } })"
					>
						<v-icon class="mr-1">mdi-pencil</v-icon>
						準備入力
					</v-btn>
					<v-btn
						class="ml-2"
						color="secondary"
						@click="$router.push({ name: 'constructions_report_edit', params: { id } })"
					>
						<v-icon class="mr-1">mdi-pencil</v-icon>
						報告書入力
					</v-btn>
				</template>
			</v-row>
			<div class="mt-4">
				<table width="100%" class="show-dialog-table">
					<tbody>
						<template v-if="!$vuetify.breakpoint.xs">
							<tr>
								<th width="15%">工事名</th>
								<td width="35%">XXXXX</td>
								<th width="15%">製番</th>
								<td width="35%">XXXXX</td>
							</tr>
							<tr>
								<th width="15%">出張先</th>
								<td width="35%">XXXXX</td>
								<th width="15%">作業責任者</th>
								<td width="35%">XXXXX</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<th width="30%">工事名</th>
								<td width="70%">XXXXXX</td>
							</tr>
							<tr>
								<th width="30%">製番</th>
								<td width="70%">XXXXXX</td>
							</tr>
							<tr>
								<th width="30%">出張先</th>
								<td width="70%">XXXXXX</td>
							</tr>
							<tr>
								<th width="30%">作業責任者</th>
								<td width="70%">XXXXXX</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
			<div class="mt-4">
				<v-tabs v-model="tab" height="40px" slider-color="primary" color="black">
					<v-tab> 確認・承認フロー </v-tab>
					<v-tab> 準備表 </v-tab>
					<v-tab> 報告書 </v-tab>
				</v-tabs>
				<v-tabs-items v-model="tab" class="pt-4" touchless>
					<v-tab-item>
						<div class="table-container">
							<table width="100%" class="show-dialog-table" :style="minWidth(500)">
								<tr>
									<th width="25%">項目</th>
									<th width="25%">役職</th>
									<th width="25%">承認・確認者名</th>
									<th width="25%">承認・確認日時</th>
								</tr>
								<tr v-for="(flow, i) in layoutSample.flows" :key="i">
									<td>{{ flow.name }}</td>
									<td>{{ flow.position }}</td>
									<td>XX XX</td>
									<td>XXXX/XX/XX</td>
								</tr>
							</table>
						</div>
					</v-tab-item>
					<v-tab-item>
						<v-row no-gutters>
							<v-col md="6" cols="12" class="pr-md-2">
								<v-sheet elevation="0">
									<div class="table-container">
										<table width="100%" class="show-dialog-table" :style="minWidth(560)">
											<tbody>
												<tr>
													<th width="20%">ロットNo.</th>
													<th width="30%">名称・材料</th>
													<th width="10%">規格</th>
													<th width="10%">単位</th>
													<th width="30%">持ち出し数量(合計量)</th>
												</tr>
												<tr v-for="n of 3" :key="n">
													<td>XXXXX</td>
													<td>XXXXXXXXX</td>
													<td>XX</td>
													<td>XX</td>
													<td>XXXXX</td>
												</tr>
											</tbody>
										</table>
									</div>
								</v-sheet>
								<v-sheet elevation="0" class="mt-4">
									<div class="table-container">
										<table width="100%" class="show-dialog-table" :style="minWidth(430)">
											<tbody>
												<tr>
													<th width="30%">検査機器類</th>
													<th width="25%">機器管理番号</th>
													<th width="20%">数量</th>
													<th width="25%">登録機器番号</th>
												</tr>
												<tr v-for="n of 3" :key="n">
													<td>XXXXXXX</td>
													<td>XX-XX</td>
													<td>XX</td>
													<td></td>
												</tr>
											</tbody>
										</table>
									</div>
								</v-sheet>
								<v-sheet elevation="0" class="mt-4">
									<div class="table-container">
										<table width="100%" class="show-dialog-table" :style="minWidth(400)">
											<tbody>
												<tr>
													<th width="30%">消耗品</th>
													<th width="25%">規格</th>
													<th width="20%">単位</th>
													<th width="25%">持出し数量</th>
												</tr>
												<tr v-for="n of 3" :key="n">
													<td>XXXXXXX</td>
													<td>XXXXX</td>
													<td>XX</td>
													<td>XXX</td>
												</tr>
											</tbody>
										</table>
									</div>
								</v-sheet>
							</v-col>
							<v-col md="6" cols="12" class="pr-md-2 mt-4 mt-md-0">
								<v-sheet elevation="0">
									<div class="table-container">
										<table width="100%" class="show-dialog-table" :style="minWidth(450)">
											<tbody>
												<tr>
													<th width="50%" colspan="2">一般工具類等</th>
													<th width="15%">規格</th>
													<th width="15%">単位</th>
													<th width="20%">持出し数量</th>
												</tr>
												<tr v-for="(tool, i) in layoutSample.tools" :key="i">
													<td width="20%">{{ tool.name }}</td>
													<td width="30%">XXXX</td>
													<td>XX</td>
													<td>XX</td>
													<td>XX</td>
												</tr>
											</tbody>
										</table>
									</div>
								</v-sheet>
								<v-sheet elevation="0" class="mt-4">
									<div class="table-container">
										<table width="100%" class="show-dialog-table" :style="minWidth()">
											<tbody>
												<tr>
													<th width="50%">リース品</th>
													<th width="30%">仕様</th>
													<th width="20%">数量</th>
												</tr>
												<tr v-for="n of 3" :key="n">
													<td>XXXXXXX</td>
													<td>XXXX</td>
													<td>XX</td>
												</tr>
											</tbody>
										</table>
									</div>
								</v-sheet>
							</v-col>
						</v-row>
					</v-tab-item>
					<v-tab-item>
						<v-row no-gutters>
							<v-col md="6" cols="12" class="pr-md-2">
								<div class="table-container">
									<table width="100%" class="show-dialog-table" :style="minWidth(450)">
										<tbody>
											<tr>
												<th width="45%" rowspan="2">移動日(行き)</th>
												<td width="25%">XX</td>
												<td width="5%">→</td>
												<td width="25%">XX</td>
											</tr>
											<tr>
												<td>XXXX/XX/XX</td>
												<td>→</td>
												<td>XXXX/XX/XX</td>
											</tr>
											<tr>
												<th rowspan="2">移動日(帰り)</th>
												<td>XX</td>
												<td>→</td>
												<td>XX</td>
											</tr>
											<tr>
												<td>XXXX/XX/XX</td>
												<td>→</td>
												<td>XXXX/XX/XX</td>
											</tr>
											<tr>
												<th width="45%">宿泊先名</th>
												<td width="55%" colspan="3">XXXXXXX</td>
											</tr>
											<tr>
												<th width="45%">走行距離</th>
												<td width="55%" colspan="3">XXX</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="table-container">
									<table width="100%" class="show-dialog-table" :style="minWidth(450)">
										<tbody>
											<tr>
												<th :rowspan="2" width="25%">移動工数</th>
												<th width="20%">社員</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
											<tr>
												<th width="20%">協力会社</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
											<tr>
												<th :rowspan="2" width="25%">移動時間</th>
												<th width="20%">社員</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
											<tr>
												<th width="20%">協力会社</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
											<tr>
												<th :rowspan="2" width="25%">宿泊</th>
												<th width="20%">社員</th>
												<td width="25%">
													<v-row no-gutters justify="space-between">
														<p>XXX</p>
														<span>泊</span>
													</v-row>
												</td>
												<td width="30%">
													<v-row no-gutters justify="space-between">
														<p>XXX</p>
														<span>円</span>
													</v-row>
												</td>
											</tr>
											<tr>
												<th width="20%">協力会社</th>
												<td width="25%">
													<v-row no-gutters justify="space-between">
														<p>XXX</p>
														<span>泊</span>
													</v-row>
												</td>
												<td width="30%">
													<v-row no-gutters justify="space-between">
														<p>XXX</p>
														<span>円</span>
													</v-row>
												</td>
											</tr>
											<tr>
												<th :rowspan="2" width="25%">作業工数</th>
												<th width="20%">社員</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
											<tr>
												<th width="20%">協力会社</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
											<tr>
												<th :rowspan="2" width="25%">残業時間</th>
												<th width="20%">社員</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
											<tr>
												<th width="20%">協力会社</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
											<tr>
												<th :rowspan="2" width="25%">休日出勤</th>
												<th width="20%">社員</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
											<tr>
												<th width="20%">協力会社</th>
												<td width="55%" colspan="2">XXX</td>
											</tr>
										</tbody>
									</table>
								</div>
							</v-col>
							<v-col md="6" cols="12" class="pl-md-2 mt-md-0 mt-4">
								<div class="table-container">
									<table width="100%" class="show-dialog-table" :style="minWidth(400)">
										<tbody>
											<tr>
												<th width="55%" colspan="3">交通便</th>
												<td width="45%">XX</td>
											</tr>
											<tr>
												<th width="55%" colspan="3">社有車台数</th>
												<td width="45%">XX</td>
											</tr>
											<tr>
												<th width="55%" colspan="3">社有車ナンバー</th>
												<td width="45%">XXXXXX</td>
											</tr>
											<tr>
												<th width="20%" rowspan="11">交通費</th>
												<th width="35%" colspan="2">電車</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="35%" colspan="2">飛行機</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="35%" colspan="2">船</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="35%" colspan="2">現地レンタカー</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="35%" colspan="2">タクシー</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="35%" colspan="2">リース費</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="35%" colspan="2">ガソリン代</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="35%" colspan="2">軽油代</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="35%" colspan="2">高速代</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="35%" colspan="2">下請け交通費</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="15%">その他</th>
												<th width="20%">(項目名)</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="25%">その他代</th>
												<th width="30%" colspan="2">宅急便代</th>
												<td width="45%">XXXXXXX</td>
											</tr>
											<tr>
												<th width="55%" colspan="3">合計</th>
												<td width="45%">XXXXXXX</td>
											</tr>
										</tbody>
									</table>
								</div>
							</v-col>

							<v-col cols="12">
								<v-sheet elevation="0" class="mt-4">
									<div class="table-container">
										<table width="100%" class="show-dialog-table" :style="minWidth(450)">
											<tbody>
												<tr>
													<th width="20%">ロットNo.</th>
													<th width="30%">名称・材料</th>
													<th width="15%">規格</th>
													<th width="15%">単位</th>
													<th width="20%">戻り数量</th>
												</tr>
												<tr v-for="n of 2" :key="n">
													<td>XXXX</td>
													<td>XXXXXXX</td>
													<td>XX</td>
													<td>XX</td>
													<td>XX</td>
												</tr>
											</tbody>
										</table>
									</div>
								</v-sheet>
								<v-sheet elevation="0" class="mt-4">
									<div class="table-container">
										<table width="100%" class="show-dialog-table" :style="minWidth(490)">
											<tbody>
												<tr>
													<th width="30%">消耗品</th>
													<th width="25%">規格</th>
													<th width="15%">単位</th>
													<th width="15%">追加数量</th>
													<th width="15%">戻り数量</th>
												</tr>
												<tr v-for="n of 2" :key="n">
													<td>XXXXXXX</td>
													<td>XXXXX</td>
													<td>XX</td>
													<td>XX</td>
													<td>XX</td>
												</tr>
											</tbody>
										</table>
									</div>
								</v-sheet>
								<v-sheet elevation="0" class="mt-4">
									<div class="table-container">
										<table width="100%" class="show-dialog-table" :style="minWidth(500)">
											<tbody>
												<tr>
													<th width="45%" colspan="2">一般工具類等</th>
													<th width="15%">規格</th>
													<th width="15%">単位</th>
													<th width="15%">戻り数量</th>
												</tr>
												<tr v-for="(tool, i) in layoutSample.tools" :key="i">
													<td width="20%">{{ tool.name }}</td>
													<td width="35%">XXXX</td>
													<td>XX</td>
													<td>XX</td>
													<td>XX</td>
												</tr>
											</tbody>
										</table>
									</div>
								</v-sheet>
								<v-sheet elevation="0" class="mt-4">
									<div class="table-container">
										<table width="100%" class="show-dialog-table" :style="minWidth(550)">
											<tbody>
												<tr>
													<th width="30%">リース品</th>
													<th width="20%">仕様</th>
													<th width="10%">数量</th>
													<th width="10%">日数</th>
													<th width="10%">運送費</th>
													<th width="10%">燃料(軽油)(L)</th>
													<th width="10%">産廃費</th>
												</tr>
												<tr v-for="n of 2" :key="n">
													<td>XXXXXXX</td>
													<td>XXXX</td>
													<td>XX</td>
													<td>XX</td>
													<td>XX</td>
													<td>XX</td>
													<td>XX</td>
												</tr>
											</tbody>
										</table>
									</div>
								</v-sheet>
							</v-col>
						</v-row>
					</v-tab-item>
				</v-tabs-items>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import ConfirmationDialog from "../shared/ConfirmationDialog.vue"
import ShowDetailRecord from "../shared/ShowDetailRecord.vue"

export default {
	components: {
		CommonFlame,
		ConfirmationDialog,
		ShowDetailRecord,
	},
	data() {
		return {
			title: "材料準備表兼報告書",
			id: this.$route.params.id,
			tab: 0,
			authority_flag: false,
			selectedUser: null,
			users: [],
			selectedRequirement: null,
			requirement_types: [],
			common,
		}
	},

	mounted() {
		// this.fetchConstructionInfo()
	},
	methods: {
		fetchConstructionInfo() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/construction_informations/${this.id}`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					// TODO
					this.authority_flag = res.data.authority_flag
					this.users = res.data.users
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		sendRequirement() {
			// TODO:
			const headers = authenticate.setHeader()
			const url = ``
			const params = {}
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					// TODO
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		confirmRequirement() {
			// TODO: ステータスごとの処理を実装する
			const headers = authenticate.setHeader()
			const url = ``
			const params = {}
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					// TODO
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		minWidth(num) {
			return { "min-width": num + "px" }
		},
	},
	computed: {
		currentStatus() {
			// TODO: 現在のステータスを返す
			return "TODO"
		},
		confirmOptions() {
			// TODO:
			return {
				title: "持出確認",
				accept_text: "持出確認",
			}
		},
		requirementOptions() {
			// TODO:
			return {
				title: "材料準備確認依頼",
				accept_text: "材料準備確認依頼",
			}
		},
		showRequirementBtn() {
			// TODO:
			return true
		},
		showConfirmationBtn() {
			// TODO:
			return true
		},
		pendingItemName() {
			// TODO: 項目名を返す
			return "材料準備確認"
		},
		layoutSample() {
			return {
				// 不使用なら削除
				flows: [
					{ name: "材料準備", position: "持出者" },
					{ name: "持出確認", position: "着工前責任者" },
					{ name: "材料返却", position: "返却者" },
					{ name: "原価投入", position: "工事部業務" },
					{ name: "照査", position: "工事部照査" },
					{ name: "承認", position: "工事部部長" },
				],
				tools: [{ name: "電工工具" }, { name: "エア工具" }, { name: "他" }],
			}
		},
	},
}
</script>

<style lang="scss" scoped>
th {
	background-color: whitesmoke;
	border-right: 1px solid white;
	font-weight: bold;
	padding: 4px;
}
td {
	border-bottom: 1px solid whitesmoke;
	padding: 4px;
	border-right: 1px solid whitesmoke;
	&:first-child {
		border-left: 1px solid whitesmoke;
	}
}
</style>